<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Типы устройств</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить тип</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="form-row mb-4">
            <div class="col-md-8">
                <div class="form-label">Название типа устройства <span class="color-red">*</span></div>
                <input type="text" class="form-control"
                       id="dev-name"
                       v-model="formData.name"
                       placeholder="Введите название">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-8">
                <div class="form-label">Стоимость в месяц (руб.) <span class="color-red">*</span></div>
                <input type="number" class="form-control"
                       id="dev-pay-per-month"
                       v-model="formData.pay_per_month"
                       placeholder="За один месяц(руб.)">
            </div>
        </div>

        <div class="mb-4">
            <div class="form-check">
                <label class="form-check-label" for="is_auto_update_available">Доступно для автообновления</label>
                <input type="checkbox"
                       class="form-check-input"
                       id="is_auto_update_available"
                       v-model="formData.is_auto_update_available">
            </div>
        </div>

        <div class="d-flex w-50 align-items-center justify-content-start">
            <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Добавить'" @btnClick="createDeviceType"/>
            <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
        </div>

        <Alert />
    </div>
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import DeviceType from "../../../../models/DeviceType";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: 'DeviceTypeCreateComponent',
    props: {
        route_back: String,
        route_create: String
    },
    components: { Alert, ConfirmBtn },
    data: function () {
        return {
            device_type: new DeviceType({
                route_create: this.route_create
            }),
            clients: [],
            formData: {
                name: '',
                pay_per_month: '',
                is_auto_update_available: 0
            },
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        createDeviceType: function () {
            if (this.formData.name === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите название типа устройства!' });
                this.toggleLoading();
                return;
            }
            if (this.formData.pay_per_month === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите стоимость за один месяц!' });
                this.toggleLoading();
                return;
            }
            let result = this.device_type.create(this.formData);
            if (result) {
                window.location.href = this.route_back;
            } else {
                console.log('error: create_device_type');
            }
        },
    },
}
</script>
